module.exports = __webpack_public_path__ + "img/vivo-bk.2f8ef57b.svg";